











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ParametroRelatorio} from '@/model/resource/ParametroRelatorio'
import {ParametroRelatorioCollection} from '@/model/collection/ParametroRelatorioCollection'
import {ListParametroRelatorioSchema} from '@/schema/resource/ParametroRelatorio/ListParametroRelatorioSchema'
import {CsvParametroRelatorioSchema} from '@/schema/resource/ParametroRelatorio/CsvParametroRelatorioSchema'

@Component
export default class ListParametroRelatorioView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListParametroRelatorioSchema()
  collection = new ParametroRelatorioCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ParametroRelatorio) {
    Helper.pushByName('editParametroRelatorio', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ParametroRelatorioCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvParametroRelatorio()
    new CsvParametroRelatorioSchema().downloadCsv(csv.all())
  }
}
